<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div id="orderTableContainer">
	<div id="quantityKey">
		<span>Quantities:</span>
		<span class="started">Work Orders Started</span>
		<span class="completed">Work Orders Completed</span>
		<span class="mismatched">Quantity Mismatch</span>
	</div>
	<table id="orderTable">
		<thead>
			<tr class="topHeader">
				<th scope="row" colspan="7">Week Number</th>
				<th *ngFor="let header of spotOrdersReportTable.headers" colspan="8">{{header.weekNumber}}</th>
			</tr>
			<tr class="secondHeader">
				<th scope="col" class="partColumn">Part</th>
				<th scope="col" class="imageColumn">Image</th>
				<th scope="col">Client</th>
				<th scope="col">Sales Order</th>
				<th scope="col">MRD Date</th>
				<th scope="col">WIP</th>
				<th scope="col">Fin</th>
				<ng-template ngFor let-header [ngForOf]="spotOrdersReportTable.headers">
					<th scope="col">{{header.monday | date: 'd-MMM'}}</th>
					<th scope="col">{{header.tuesday | date: 'd-MMM'}}</th>
					<th scope="col">{{header.wednesday | date: 'd-MMM'}}</th>
					<th scope="col">{{header.thursday | date: 'd-MMM'}}</th>
					<th scope="col">{{header.friday | date: 'd-MMM'}}</th>
					<th scope="col" class="weekend">{{header.saturday | date: 'd-MMM'}}</th>
					<th scope="col" class="weekend">{{header.sunday | date: 'd-MMM'}}</th>
					<th scope="col" class="weekTotal">Total</th>
				</ng-template>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let row of spotOrdersReportTable.rows">
				<th scope="row" class="partColumn" style="background: {{row.rowBackgroundColour}}"><a href="/admin/parts/{{row.partId}}" target="_blank" style="display: inline-block; width: 150px;">{{row.partNumber}}</a></th>
				<th scope="row" class="imageColumn" style="text-align:center; background: {{row.rowBackgroundColour}}"><img style="max-height:75px; width: 150px;" *ngIf="row.partImageUrl != ''" src="{{row.partImageUrl}}"/></th>
				<th scope="row" style="background: {{row.rowBackgroundColour}}">{{row.clientName}}</th>
				<th scope="row" style="background: {{row.rowBackgroundColour}}"><a href="/admin/salesOrders/{{row.salesOrderLookupId}}" target="_blank" style="display: inline-block; width: 150px;">{{row.salesOrderId}}</a>  <i *ngIf="row.isLinked" class="fal fa-link"></i></th>
				<th scope="row" style="background: {{row.rowBackgroundColour}}">{{row.salesOrderMRDDate}}</th>
				<th scope="row" style="background: {{row.rowBackgroundColour}}">{{row.wipStock}}</th>
				<th scope="row" style="background: {{row.rowBackgroundColour}}">{{row.availableStock}}</th>
				<ng-template ngFor let-quantity [ngForOf]="row.workOrderQuantities">
					<td class="{{quantity.monday.class}}">{{(quantity.monday.quantity > 0 ? quantity.monday.quantity : '' )}} <i *ngIf="quantity.monday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="{{quantity.tuesday.class}}">{{(quantity.tuesday.quantity > 0 ? quantity.tuesday.quantity : '' )}} <i *ngIf="quantity.tuesday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="{{quantity.wednesday.class}}">{{(quantity.wednesday.quantity > 0 ? quantity.wednesday.quantity : '' )}} <i *ngIf="quantity.wednesday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="{{quantity.thursday.class}}">{{(quantity.thursday.quantity > 0 ? quantity.thursday.quantity : '' )}} <i *ngIf="quantity.thursday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="{{quantity.friday.class}}">{{(quantity.friday.quantity > 0 ? quantity.friday.quantity : '' )}} <i *ngIf="quantity.friday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="{{quantity.saturday.class}} weekend">{{(quantity.saturday.quantity > 0 ? quantity.saturday.quantity : '' )}} <i *ngIf="quantity.saturday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="{{quantity.sunday.class}} weekend">{{(quantity.sunday.quantity > 0 ? quantity.sunday.quantity : '' )}} <i *ngIf="quantity.sunday.isDelivered" class="fal fa-check delivered"></i></td>
					<td class="weekTotal">{{(quantity.total.quantity > 0 ? quantity.total.quantity : '' )}}</td>
				</ng-template>
			</tr>
		</tbody>
	</table>
</div>